import { TopBar } from '@openx/components-table/ChipFilters/TopBar';
import type { FiltersT } from '@openx/components-table/serverSideCriteriaProcessing';
import type { FiltersConfig } from '@openx/types/chipFilters';
import { type AllTableCriteria, CriteriaDimension } from '@openx/types/tableCriteria';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { TaxonomyListFilters } from '../types';

type FilterChange = {
  dimension: typeof CriteriaDimension.FILTERS;
  value: TaxonomyListFilters;
};

export interface TaxonomyTopBarProps {
  onChange: (filters: FilterChange) => void;
  criteria: AllTableCriteria<FiltersT>;
  filtersConfig: FiltersConfig;
}

export const TaxonomyTopBar = memo(({ onChange, criteria, filtersConfig }: TaxonomyTopBarProps) => {
  const { t } = useTranslation();

  const handleFiltersChange = useCallback(
    newFilters => {
      onChange({
        dimension: CriteriaDimension.FILTERS,
        value: newFilters,
      });
    },
    [onChange]
  );

  return (
    <TopBar
      filters={criteria.filters}
      onChange={handleFiltersChange}
      searchText={t('Search Name or Description')}
      chipFiltersConfig={filtersConfig}
    />
  );
});
